/* assets/wl-g2-kp-buybox.js · Woodlit G2 buy box (Pergolux R08, R10, R18; SB-P0, 5 Oct 2026). Deferred, after theme.js.
   Works on top of the theme; never edits theme.js. Contact taps and chat are G1's (wl-g1-chrome.js).
   Owner override O1: no gallery code here (no counter, no 3D chip, no arrows); wl-gallery.js is left alone.
   Fix wave 1 (7 Oct 2026): the stuck header is measured on .theme__header (the wrapper is 0px high), so the bar shows as
   soon as Order now slides under the header (QA F3); the delivery, help and price-hold lines also make the chat launcher
   step aside (QA F6, G1 float manager).
   Fix wave 3 (10 Oct 2026, browser QA pass 3 F2): the bar and the header no longer switch each other on and off. The stuck
   header counts at its full height while it is slid up, the 100px header-hide count starts again when the bar appears, and
   the header never hides while an Order now control is fully on screen, so hiding the header can never reveal Order now and
   hide the bar (F3: the price hold keeps "14 days" on one line). */
(function () {
  'use strict';
  if (window.wlG2) return;
  window.wlG2 = { v: 'p0' };
  var html = document.documentElement;

  function track(name, value) {
    try {
      var p = { placement: 'pdp' };
      if (value != null) p.value = String(value);
      if (typeof window.wlTrack === 'function') window.wlTrack(name, p);
      else if (typeof window.clarity === 'function') window.clarity('event', name);
    } catch (e) {}
  }
  var data = null;
  try { var dEl = document.getElementById('wl-g2-data'); if (dEl) data = JSON.parse(dEl.textContent); } catch (e) {}

  var bar = document.getElementById('cart-bar');
  var sec = (bar && bar.closest('[data-section-type="product"]')) || document.querySelector('[data-section-type="product"]') || document;
  var formBtn = sec.querySelector('[data-product-form] [data-add-to-cart]');
  var notifyBtn = sec.querySelector('.product__content .product-soldout-notification [data-popup-open]');
  var hdrEl = document.querySelector('[data-header-wrapper]');
  var hdrIn = hdrEl ? (hdrEl.querySelector('.theme__header') || hdrEl) : null;

  /* 0. G1 float manager: the chat launcher fades while it would cover these: the in-form buttons and the lines under them. */
  [formBtn, notifyBtn].forEach(function (el) { if (el) el.setAttribute('data-wl-avoid-float', ''); });
  Array.prototype.forEach.call(sec.querySelectorAll('.product__content [data-wl-g2="delivery"], .product__content [data-wl-g2="help"], .product__content details.wl-lock > summary'), function (el) {
    el.setAttribute('data-wl-avoid-float', '');
  });
  /* SB14 final fixes (19 Oct 2026, QA: the chat launcher covered the campaign bar's countdown): the campaign bar on the
     product page is a dodge obstacle like the price (data-wl-dodge-float). Set here so snippets/wl-sale.liquid stays byte
     identical to live; the float manager reads the attribute on every placement (it queries [data-wl-dodge-float] each
     time and runs after this deferred file), and a bar the theme renders again is tagged in the same mutation round that
     makes the float manager place again. */
  var pcEl = sec.querySelector('.product__content') || document.querySelector('.product__content');
  var tagBars = function () {
    if (!pcEl) return;
    Array.prototype.forEach.call(pcEl.querySelectorAll('.wl-sale-bar:not([data-wl-dodge-float])'), function (el) {
      el.setAttribute('data-wl-dodge-float', '');
    });
  };
  tagBars();
  if (pcEl && window.MutationObserver) {
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) for (var j = 0; j < ms[i].addedNodes.length; j++) {
        var n = ms[i].addedNodes[j];
        if (n.nodeType === 1 && (n.classList.contains('wl-sale-bar') || n.querySelector('.wl-sale-bar'))) { tagBars(); return; }
      }
    }).observe(pcEl, { childList: true, subtree: true });
  }
  /* The price hold heading never breaks between the number and its unit ("14 giorni", "14 días", "14 dienų"). */
  Array.prototype.forEach.call(document.querySelectorAll('details.wl-lock > summary'), function (el) {
    Array.prototype.forEach.call(el.childNodes, function (n) {
      if (n.nodeType === 3 && /\d \S/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/(\d) (?=\S)/g, '$1\u00a0');
    });
  });

  /* 1. Sticky bar (R08): visible unless an Order now control is fully visible below the stuck header. */
  var shown = null;
  function setUp(v) {
    if (hdrEl && hdrEl.classList.contains('wl-hdr-up') !== v) hdrEl.classList.toggle('wl-hdr-up', v);
  }
  if (bar && bar.classList.contains('wl-sb')) {
    bar.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.product__submit__add');
      if (b && !b.disabled && !b.classList.contains('product__cart-bar-notification-button')) track('sticky_order_now');
    }, true);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () {
      if (bar.offsetHeight) html.style.setProperty('--cart-bar-height', bar.offsetHeight + 'px');
    });
  }
  var managed = !!(bar && bar.classList.contains('wl-sb') && formBtn && 'IntersectionObserver' in window && !bar.querySelector('.all-variants--soldout'));
  if (managed) {
    var dtl = bar.classList;
    var nativeToggle = DOMTokenList.prototype.toggle;
    /* theme.js toggleCartBarOnScroll calls classList.toggle('is-visible', s) on every theme:scroll: make it a no-op. */
    dtl.toggle = function (t, f) { return t === 'is-visible' ? dtl.contains(t) : nativeToggle.apply(dtl, arguments); };

    var targets = [formBtn];
    if (notifyBtn) targets.push(notifyBtn);
    Array.prototype.forEach.call(document.querySelectorAll('[data-wl-order-mirror]'), function (el) { targets.push(el); });
    var ratio = targets.map(function () { return 0; });
    var io = null, ioTop = -1, firedInView = false;
    /* Header anchors (part 2): last scroll direction, the position where it started, the bottom limit. */
    var dir = 0, anchor = 0, maxY = 0;

    var setShown = function (v) {
      if (v === shown) return;
      shown = v;
      if (v) {
        /* The bar has just appeared: the 100px header-hide count starts here, so the header never hides in the same
           moment (a scroll up resets the anchor as usual). */
        anchor = window.pageYOffset || document.documentElement.scrollTop || 0;
        if (!dtl.contains('is-visible')) dtl.add('is-visible');
        if (!html.classList.contains('wl-sb-on')) html.classList.add('wl-sb-on');
      } else {
        if (dtl.contains('is-visible')) dtl.remove('is-visible');
        if (html.classList.contains('wl-sb-on')) html.classList.remove('wl-sb-on');
        setUp(false);
      }
    };
    var evaluate = function () {
      var seen = false;
      for (var i = 0; i < ratio.length; i++) if (ratio[i] >= 0.99) seen = true;
      setShown(!seen);
    };
    var onIO = function (entries) {
      entries.forEach(function (en) {
        var i = targets.indexOf(en.target);
        if (i < 0) return;
        ratio[i] = en.isIntersecting ? en.intersectionRatio : 0;
        if (en.target === formBtn && !firedInView && ratio[i] >= 0.5) { firedInView = true; track('order_now_in_view'); }
      });
      evaluate();
    };
    /* Height of the stuck header that covers the top of the screen. The wrapper is 0px high (its .theme__header child is
       absolutely positioned), so measure the child. offsetTop and offsetHeight ignore transforms: a header sliding back in
       counts at its full height at once, so the bar never hides early. While the header is slid up (wl-hdr-up) it still
       counts at its full height: the slide is caused by the bar, so it must not reveal Order now and hide the bar again
       (QA pass 3 F2: 2 to 12 bar and header flips per crossing). */
    var cover = function () {
      if (!hdrEl || !hdrEl.classList.contains('js__header__stuck')) return 0;
      var h = hdrIn === hdrEl ? hdrEl.offsetHeight : hdrIn.offsetTop + hdrIn.offsetHeight;
      var t = hdrEl.getBoundingClientRect().top;
      return Math.max(0, Math.round(Math.max(h, hdrEl.offsetHeight) + (t > 0 ? t : 0)));
    };
    var observe = function (force) {
      var top = cover();
      if (!force && io && top === ioTop) return;
      ioTop = top;
      if (io) io.disconnect();
      io = new IntersectionObserver(onIO, { rootMargin: '-' + top + 'px 0px 0px 0px', threshold: [0, 0.5, 0.99, 1] });
      targets.forEach(function (t) { io.observe(t); });
    };
    observe(true);
    if (hdrEl) {
      /* theme.js may rewrite the header class every frame near the top (unstickSimple); act only on stuck state changes
         (wl-hdr-up no longer changes the covered height). */
      var lastHdr = '', hdrT = 0;
      new MutationObserver(function () {
        var s = hdrEl.classList.contains('js__header__stuck') ? 's' : '';
        if (s === lastHdr) return;
        lastHdr = s;
        observe(false);
        /* custom.css animates the stuck header's padding for 0.3s: measure again once it has settled. */
        clearTimeout(hdrT);
        hdrT = setTimeout(function () { observe(false); }, 360);
      }).observe(hdrEl, { attributes: true, attributeFilter: ['class'] });
    }
    var rz = 0;
    window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { observe(true); }, 150); });
    document.addEventListener('theme:resize', function () { observe(true); });

    /* 2. Header hides on scroll down while the bar shows, returns on scroll up (R08). theme:scroll comes from theme.js. */
    var blocked = function () {
      return html.hasAttribute('data-scroll-locked') || html.classList.contains('wl-pswp-open') || html.classList.contains('wl-overlay-open') ||
        !!document.querySelector('header-drawer.is-open, .meganav--visible');
    };
    /* Read now, not from the last IntersectionObserver round: after a long jump the observer has not reported yet, and an
       Order now control that is already fully on screen will hide the bar in a moment, so the header stays. */
    var orderSeen = function () {
      var top = cover(), bottom = window.innerHeight;
      for (var i = 0; i < targets.length; i++) {
        var r = targets[i].getBoundingClientRect();
        if (r.height > 0 && r.top >= top - 1 && r.bottom <= bottom + 1) return true;
      }
      return false;
    };
    document.addEventListener('theme:scroll', function (e) {
      var d = e.detail || {}, y = d.position;
      if (typeof y !== 'number' || y < 0) return;
      if (y > maxY) { maxY = document.documentElement.scrollHeight - window.innerHeight; if (y > maxY) return; }
      if (!shown || blocked()) { setUp(false); return; }
      var nd = d.down ? 1 : (d.up ? -1 : 0);
      if (!nd) return;
      if (nd !== dir) { dir = nd; anchor = y; }
      if (dir === 1 && y - anchor >= 100 && hdrEl && hdrEl.classList.contains('js__header__stuck') && !hdrEl.classList.contains('wl-hdr-up') && !orderSeen()) setUp(true);
      else if (dir === -1 && anchor - y >= 20) setUp(false);
    });
  }

  /* 3. Delivery line follows the selected variant (R10): multi-variant products only. */
  if (data && data.vs) {
    document.addEventListener('theme:variant:change', function (e) {
      var line = document.querySelector('[data-wl-g2="delivery"]');
      if (!line || !e.target || !e.target.contains || !e.target.contains(line)) return;
      var v = e.detail && e.detail.variant;
      var st = v ? data.vs[String(v.id)] : null;
      if (!st || !st[0]) { line.hidden = true; return; }
      line.hidden = false;
      if (st[1]) line.removeAttribute('data-wl-nostock'); else line.setAttribute('data-wl-nostock', '');
    });
  }

  /* 4. Price hold (R18, R31): one event per submit; G9's popup rule reads the timestamp. */
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.id === 'price-lock-form') {
      track('price_hold');
      try { window.localStorage.setItem('wl_price_hold_at', String(Date.now())); } catch (x) {}
    }
  }, true);
})();
